import { Card, Typography } from "antd";
import { Flex } from "common/components/flex/flex";

const { Title } = Typography;

export const Section = ({ title, extra, children }) => (
  <Card bodyStyle={{ padding: 16 }}>
    <Flex direction="column" gap={20}>
      <Flex justify="space-between" align="center">
        <Title level={4} className="section__title">
          {title}
        </Title>
        {extra}
      </Flex>
      {children}
    </Flex>
  </Card>
);
